var pageWidth = 0;

$(document).ready(function() {

  // Setup handling of window resizing
  var pageWidth = $(window).width();
  var windowResizing;
  window.onresize = function(){
    clearTimeout(windowResizing);
    windowResizing = setTimeout(windowResized, 100);
  };

  // Smooth scrolling using jQuery easing
  $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      console.log(target);
      if (target.length) {
        $('html, body').animate({
          scrollTop: (target.offset().top - 54)
        }, 1000, "easeInOutExpo");
        return false;
      }
    }
  });

  // Closes responsive menu when a scroll trigger link is clicked
  $('.js-scroll-trigger').click(function() {
    $('.navbar-collapse').collapse('hide');
  });

  // Activate scrollspy to add active class to navbar items on scroll
  $('body').scrollspy({
    target: '#mainNav',
    offset: 56
  });

  // Collapse Navbar
  var navbarCollapse = function() {
    if ($("#mainNav").offset().top > 100) {
      $("#mainNav").addClass("navbar-shrink");
    } else {
      $("#mainNav").removeClass("navbar-shrink");
    }
  };
  // Collapse now if page is not at top
  navbarCollapse();
  // Collapse the navbar when page is scrolled
  $(window).scroll(navbarCollapse);


  // Handle Resizing
  initializeSizing();
  setTimeout(function(){  //window.resizeBy(-100, 0);
    initializeSizing();
  }, 2000); // 3000

});


function initializeSizing(){

  //imageInlineSizing();
  photobarSizing();

}


// Function to help manage image sizing on the full width bars that have an image background along with content
function photobarSizing(){

  $(".photobar").each(function() {

    // Pre-find the image since we use it a lot
    var theBannerImage = $(this).children(".photobar-image").find("img");

    var contentHeight = $(this).find(".photobar-content").height();
    var contentWidth = $(this).width();

console.log('contentWidth: '+contentWidth);
console.log('contentHeight: '+contentHeight);

    var preliminaryImageHeight =  theBannerImage.height();
    var preliminaryImageWidth =  theBannerImage.width();

console.log('preliminaryImageWidth: '+preliminaryImageWidth);
console.log('preliminaryImageHeight: '+preliminaryImageHeight);


    // Force the image container height to match content
     $(this).children(".photobar-image").css("height",contentHeight);

    // Adjust image dimensions if needed
    if (preliminaryImageHeight < contentHeight){
console.log('less');

      // Recalculate image dimensions to fill height (overflow is hidden)
      var newImageWidth = (preliminaryImageWidth/preliminaryImageHeight)*contentHeight;
      theBannerImage.height(contentHeight);
      theBannerImage.width(newImageWidth);

      $(this).children(".photobar-image").children(".outer-container").width(newImageWidth);

      $(this).children(".photobar-image").find("img").parent().width(newImageWidth);

console.log('newImageWidth: '+newImageWidth);
console.log('newImageHeight: '+contentHeight);



    }else{
console.log('more');

      theBannerImage.height('auto');
      theBannerImage.width(contentWidth);


    }

  });

}

function windowResized(){

  var newPageWidth = $(window).width();

  if (newPageWidth != pageWidth){
    console.log('TEST');
    photobarSizing();
    pageWidth = newPageWidth;

  }


}



// WEBPACK FOOTER //
// ./resources/assets/js/public/global.js